// extracted by mini-css-extract-plugin
export default {"captchaContainer":"Captcha--captchaContainer--9cd718","errorMessage":"Captcha--errorMessage--f637a6"};